import React from 'react'

import { Link, useHistory } from 'react-router-dom'

import { Box, Typography, TextField } from '@material-ui/core'
import PersonIcon from '@material-ui/icons/PersonOutlineOutlined'
import SettingsIcon from '@material-ui/icons/SettingsOutlined'
import AttachMoney from '@material-ui/icons/AttachMoneyOutlined'

import { KeyboardDatePicker } from '@material-ui/pickers'
import TableTaxes from './components/TableTaxes'
import { routes } from 'routes'
import Footer from './components/Footer'
import ModalSuccess from 'components/ModalSuccess'
import DisplayInvoicePlan from './components/DisplayInvoicePlan'
import { reverse } from 'named-urls'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import moment from 'moment'
import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'

const DetachedInvoiceConfirm = () => {
  const history = useHistory()
  const snackbar = useSnackbar()
  const context = React.useContext(DetachedInvoiceContext)
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    history.push(reverse(routes.invoices.all))
  }

  const normalizePlan = plans =>
    plans.map(plan => {
      if (plan.description) {
        return {
          description: plan.description,
          price: plan.typeEntry === 'discount' ? -plan.price : plan.price,
        }
      }
      return {
        plan_code: plan.plan.code,
        price: plan.price || plan.plan.price,
        from: plan.from ? moment(plan.from).format('YYYY/MM/DD') : '',
        till: plan.till ? moment(plan.till).format('YYYY/MM/DD') : '',
      }
    })

  const createDetachedInvoice = async () => {
    setLoading(true)
    try {
      await service.recurrence.invoices.detached({
        invoice: {
          customerId: context.data.customer.id,
          dueDate: context.data.dueDate,
          taxes: context.data.taxes.map(tax => ({ id: tax.id })),
          settings: [
            {
              settingTag: 'generate_service_tax_invoices',
              value: context.data.isTax,
            },
          ],
          items: normalizePlan(context.data.plans),
        },
      })
      handleOpen()
    } catch {
      snackbar.open({
        message: 'Falha ao criar a fatura!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Box p={3}>
        <Box display="flex" alignItems="center">
          <Box mr={4}>
            <PersonIcon fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Cliente
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          flexGrow={1}
          flexDirection={{
            xs: 'column',
            sm: 'row',
          }}
        >
          <Box flex={1} mr={6}>
            <TextField
              margin="dense"
              label="Nome"
              value={context.data.customer.name}
              variant="outlined"
              fullWidth
              disabled
            />
            <TextField
              margin="dense"
              label="E-mail"
              value={context.data.customer.email}
              variant="outlined"
              fullWidth
              disabled
            />
          </Box>
          <Box flex={1} mr={6}>
            <TextField
              margin="dense"
              label="CPF/CNPJ"
              value={context.data.customer.cpf}
              variant="outlined"
              fullWidth
              disabled
            />
            <TextField
              margin="dense"
              label="Pessoa"
              value={
                context.data.customer.cpf ? 'Pessoa fisica' : 'Pessoa juridica'
              }
              variant="outlined"
              fullWidth
              disabled
            />
          </Box>
        </Box>

        <Box mt={6}>
          <DisplayInvoicePlan plans={context.data.plans} />
        </Box>

        <Box display="flex" alignItems="center" mt={6}>
          <Box mr={4}>
            <SettingsIcon fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Configurações
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          flexGrow={1}
          flexDirection={{
            xs: 'column',
            sm: 'row',
          }}
          alignItems="flex-end"
        >
          <Box flex={1} mr={6}>
            <KeyboardDatePicker
              margin="dense"
              variant="outlined"
              placeholder="Data de vencimento da fatura"
              format="dd/MM/yyyy"
              name="from"
              disablePast
              value={context.data.dueDate}
              maxDate={null}
              fullWidth
              disabled
            ></KeyboardDatePicker>
          </Box>
          <Box flex={1} mr={6}>
            <Typography color="textSecondary">Emitir nota fiscal?</Typography>
            <TextField
              margin="dense"
              value={context.data.isTax}
              variant="outlined"
              SelectProps={{ native: true }}
              select
              fullWidth
              disabled
            >
              <option value={true}>Sim</option>
              <option value={false}>Não</option>
            </TextField>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt={6}>
          <Box mr={4}>
            <AttachMoney fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Impostos
            </Typography>
          </Box>
        </Box>
        <Box mr={6}>
          <TableTaxes taxes={context.data.taxes} readOnly={true} />
        </Box>
      </Box>
      <ModalSuccess open={open} onClose={handleClose}>
        Fatura avulsa criada!
      </ModalSuccess>
      <Box p={3}>
        <Footer
          prevButtonProps={{
            component: Link,
            to: routes.invoices.steps.settings,
          }}
          nextButtonProps={{
            onClick: createDetachedInvoice,
            disabled: loading,
          }}
          nextButtonText="Criar fatura"
        />
      </Box>
    </>
  )
}

export default DetachedInvoiceConfirm
